/**
 * Whether a listed entry has a state chip to show.
 *
 * A workspace module's entry carries `state: { id, name }`. An AutoCount connector entry carries
 * `state: { stateId, name }` and no `id` (SS06276, SS06277): FTSState resolves either against the
 * module's states, so a guard that asks only for `id` hid the chip on every AutoCount card and in
 * the detail view while the table view, which has no guard, showed it.
 */
export const hasEntryState = (state) => !!(state && (state.id || state.stateId));

/**
 * The canvas state id a listed entry is in, for matching against an activity's `fromStates`:
 * `id` for a workspace module's entry, `stateId` for a connector entry (see hasEntryState).
 * Comparing `state.id` alone matched no from-state for a connector entry, so every state-bound
 * activity was hidden. Undefined when the entry has no state.
 */
export const entryStateId = (state) => (state ? state.id || state.stateId : undefined);
